import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { Subtitle, UpperTitle } from "../StyledComponents";

const formatValue = (raw) => {
  if (!raw) return "0.0";
  const number = parseInt(raw, 10);
  return (number / 10).toFixed(1);
};

const DecimalInput = ({ onChange, unit }) => {
  const [rawValue, setRawValue] = useState("");

  const handleKeyDown = (e) => {
    const isBackspace = e.key === "Backspace";
    const isDigit = /^[0-9]$/.test(e.key);

    if (isDigit) {
      const newRaw = (rawValue + e.key).slice(-8); // avoid long overflow

      const numeric = parseInt(newRaw, 10);
      if (numeric / 10 > 12) {
        e.preventDefault();
        return;
      }

      setRawValue(newRaw);
      onChange(formatValue(newRaw));
      e.preventDefault();
    } else if (isBackspace) {
      const newRaw = rawValue.slice(0, -1);
      setRawValue(newRaw);
      onChange(formatValue(newRaw));
      e.preventDefault();
    } else {
      e.preventDefault();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <input
        type="text"
        value={formatValue(rawValue)}
        onKeyDown={handleKeyDown}
        onChange={() => {}}
        inputMode="numeric"
        style={{
          width: "60px",
          textAlign: "center",
          fontSize: "1.25rem",
          fontWeight: "bold",
          border: "none",
          borderBottom: "1px solid #ccc",
          backgroundColor: "transparent",
          padding: "2px 4px",
          outline: "none",
        }}
      />
      {unit && (
        <span
          style={{
            fontSize: "0.9rem",
            fontWeight: "500",
            color: "#666",
          }}
        >
          {unit}
        </span>
      )}
    </div>
  );
};

const InfoSingleCard = ({ item, setValue, editable }) => {
  const {
    label,
    value,
    unit,
  } = item || {};

  // const handle

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "12px 0"
      }}
    >
      <Row noGutters style={{ marginBottom: "6px" }}>
        {editable ? (
          <DecimalInput
            unit={unit}
            onChange={setValue}
          />
        ) : (
          <UpperTitle>{`${unit ? `${value} ${unit}` : value}`}</UpperTitle>
        )}
      </Row>
      <Row noGutters>
        <Subtitle>{label}</Subtitle>
      </Row>
    </div>
  );
};

export default InfoSingleCard;